const FAMILY = { kg: ["mass", 1000], g: ["mass", 1], L: ["vol", 1000], l: ["vol", 1000], ml: ["vol", 1] };
export const RECIPE_UNITS = ["g", "kg", "ml", "L", "un"];
export const YIELD_UNITS = ["kg", "g", "L", "ml", "un"];
export const PORTION = "porcao";
const r2 = (v) => Math.round((v + Number.EPSILON) * 100) / 100;
export const unitLabel = (u) => (u === PORTION ? "porção" : u);

export function convert(qty, from, to) {
  if (from === to) return qty;
  const a = FAMILY[from];
  const b = FAMILY[to];
  if (!a || !b || a[0] !== b[0]) return null;
  return (qty * a[1]) / b[1];
}

export const defaultRecipeUnit = (productUnit) => ({ kg: "g", L: "ml" }[productUnit] || productUnit || "un");
export const sourceKey = (i) => (i.kind === "recipe" ? `r:${i.recipe_id}` : `p:${i.product_id}`);

export function buildSources(products, recipes, selfId) {
  const out = {};
  products.forEach((p) => { out[`p:${p.id}`] = { ...p, kind: "product" }; });
  recipes.filter((r) => r.is_base && r.id !== selfId).forEach((r) => {
    out[`r:${r.id}`] = { id: r.id, kind: "recipe", name: r.name, unit: r.yield_unit || PORTION, yield_qty: r.yield_qty, unit_cost: r.yield_unit_cost, portion_cost: r.cost_per_portion, total_cost: r.total_cost, yield_portions: r.yield_portions, category_name: "Preparo base" };
  });
  return out;
}

export function sourceUnits(src) {
  if (!src) return RECIPE_UNITS;
  if (src.kind !== "recipe") return [...new Set([src.unit, ...RECIPE_UNITS])];
  const fam = FAMILY[src.unit]?.[0];
  const same = src.yield_qty ? YIELD_UNITS.filter((u) => u === src.unit || (fam && FAMILY[u]?.[0] === fam)) : [];
  return [...same, PORTION];
}

export function ingredientCalc(ing, src) {
  const gross = Number(ing.qty_gross) || 0;
  const loss = Math.min(Math.max(Number(ing.loss_pct) || 0, 0), 99);
  const res = { qtyNet: gross * (1 - loss / 100), factor: 1 / (1 - loss / 100), unitCost: src?.unit_cost ?? null, cost: 0, incompatible: false, productUnit: src?.unit };
  if (!src) return res;
  const base = src.kind === "recipe";
  if (ing.unit === PORTION) return base ? { ...res, cost: r2((gross / (src.yield_portions || 1)) * (src.total_cost || 0)) } : { ...res, incompatible: true };
  if (base && !src.yield_qty) return { ...res, incompatible: true };
  const q = convert(gross, ing.unit || src.unit, src.unit);
  if (q === null) return { ...res, incompatible: true };
  return { ...res, cost: r2(base ? (q / src.yield_qty) * (src.total_cost || 0) : q * (src.unit_cost || 0)) };
}

export function recipeTotals(costs, portions, price, target) {
  const total = costs.reduce((a, c) => a + c, 0);
  const per = total / (portions > 0 ? portions : 1);
  return {
    total,
    perPortion: per,
    cmvPct: price ? (per / price) * 100 : null,
    margin: price ? price - per : null,
    marginPct: price ? ((price - per) / price) * 100 : null,
    suggested: target > 0 ? per / (target / 100) : null,
  };
}

export function cmvTone(pct, target) {
  if (pct === null || pct === undefined) return "muted";
  if (pct <= target) return "success";
  if (pct <= target + 5) return "warning";
  return "danger";
}
